export const LeadsSource = {
  0: '线索平台PC端',
  1: 'api-讯达',
  2: 'api-MKT',
  3: 'api-External',
  4: '线索平台小程序',
  5: '其他小程序',
  999: 'api-其他',
};

export const LeadsOperationType = {
  // 1: '更新姓名',
  // 2: '更新性别',
  // 3: '更新所在地',
  // 4: '更新手机号',
  // 5: '更新邮箱',
  6: '变更线索评分',
  // 7: '更新个人信息',
  // 8: '更新qq',
  // 9: '更新微信号',
  10: '下载线索详情',
  11: '分配线索',
  // 12: '更新memo',
  13: '变更线索状态',
  // 14: '更新bundle',
  // 15: '有效线索上报',
  // 16: '潜在客户数据',
  // 17: '离线归因线索数据',
  // 18: '更新账户独立密码',
  // 19: '用户属性，潜在客户数据上报',
  20: '下载咨询信息',
  // 21: '更新账户角色加密配置',
  // 22: '临时链接更新联系人信息',
  // 23: '更新职业',
  // 24: '更新工作年限',
  // 25: '更新身份证号码',
  // 26: '更新详细地址',
  // 27: '更新国籍',
  // 28: '更新年龄',
  // 29: '字段值映射配置',
  // 30: '多级字段拆解配置',
  // 31: '推送规则配置',
  32: '下载通话记录信息',
  // 33: '外部线索导入',
  34: '更新线索分配方式',
  35: '更新线索分配规则',
  // 36: '调整线索分配自定义规则顺序',
  // 37: '用户留资短信触达设置',
  // 38: '删除员工',
  // 39: '更改员工线索接收状态',
  // 40: '更改员工登录状态',
  // 41: '新增跟进记录',
  // 42: '更改线索分配短信通知设置',
  // 43: '更新自定义列',
  44: '双向回呼拨打电话',
  // 45: '新增员工',
  // 46: '更新员工',
  // 47: '更新团队',
  // 48: '设置隐藏重复线索',
  // 49: '设置隐藏外部导入线索',
  // 50: '申请绑定子账号',
  // 51: '确认绑定授权',
  // 52: '拒绝绑定授权',
  // 53: '撤销绑定申请',
  // 54: '申请解除授权',
  // 55: '撤销解绑申请',
  // 56: '确认解绑',
  // 57: '新建清洗规则',
  // 58: '修改清洗规则',
  // 59: '删除清洗规则',
  // 60: '新建外呼行业话术',
  // 61: '删除外呼行业话术',
  62: '人工外呼',
  63: '获取中间号失败后双向回呼拨打电话',
  // 64: '微信公众号授权',
  // 65: '微信用户标签管理',
  // 66: '微信用户标签规则管理',
  // 67: '添加微信公众号粉丝标签',
  // 68: '更新微信公众号粉丝标签',
  // 69: '微信公众号粉丝归因',
  // 70: '微信公众号消息发送规则管理',
  // 71: '修改微信公众号粉丝意向评分',
  // 72: '微信通过公众号绑定广告主',
  // 73: '外部线索导入',
  // 74: '更新外部线索状态信息',
  // 75: '转移线索分配人并删除员工',
  // 76: '修改外呼行业话术',
  // 77: '更新线索联系人信息',
  // 78: '更新归因信息',
  // 79: '更新线索基本信息',
  // 80: '更新outeruniquekey信息',
  // 81: '同意了第三方授权',
  // 82: '第三方授权验证成功',
  // 83: '第三方授权取消成功',
  // 84: '更新线索自定义属性',
  // 85: '战败线索导入',
  // 86: '线索同步规则配置',
  // 87: '到店上报',
  88: '更新线索分配去重设置',
  // 89: '成单上报',
  // 90: '添加标签分组',
  // 91: '更新标签分组',
  // 92: '删除标签分组',
  // 93: '添加标签',
  // 94: '更新标签',
  // 95: '删除标签',
  96: '更新线索标签',
  // 97: '更新线索的第三方标签',
  // 98: '下载导入线索失败文件',
  // 99: '无效线索上报',
  // 100: '更新企业微信客户的手机',
  // 101: '更新企业微信客户的跟进状态',
  // 102: '添加企业微信客户的跟进记录',
  // 103: '更新企业微信员工信息',
  // 104: '新增企业团队',
  // 105: '更新企业团队',
  // 106: '删除企业团队',
  // 107: '新增回访消息提醒',
  // 108: '更新回访消息提醒',
  // 109: '删除回访消息提醒',
  // 110: '新增跟进消息提醒',
  // 111: '更新跟进消息提醒',
  // 112: '删除跟进消息提醒',
  // 113: '更新通讯录secret',
  // 114: '更新客户联系secret',
  // 115: '更新会话存档secret',
  // 116: '企业授权',
  // 117: '企业取消授权',
  // 118: '更新企业授权成员的范围',
  // 119: '用户加入授权列表',
  // 120: '用户从授权列表删除',
  // 121: '企业微信员工绑定',
  // 122: '企业微信员工解绑',
  // 123: '更新企业微信客户的备注',
  // 124: '更新企业微信客户的标签',
  // 125: '表单线索上报',
  126: '下载企业微信客户列表',
  // 127: '更新门店信息',
  // 128: '更新线索分层上报DMP规则',
  // 129: '编辑企微上报规则',
  // 130: '线索列表去重开关设置',
  // 131: '更新账户角色企微加密配置',
  // 132: '更新账户角色线索接收状态编辑配置',
  // 133: '新增团队',
  // 134: '删除团队',
  // 135: '闪信触达设置',
  // 136: '更改员工的线索接收数量上限',
  // 137: '更新闪信的主体名称',
  154: '增加线索回收规则',
  155: '回收线索',
  156: '认领线索',
  157: '开启自动回收规则',
  158: '关闭自动回收规则',
  159: '开启认领回收线索按钮',
  160: '关闭认领回收线索按钮',
  161: '更新线索回收规则',
  170: "拨打网络电话",
  171: "提交外呼清洗任务",
};

export const LeadsComeFrom = {
  0: '免登录',
  1: '内部运营系统',
  2: '服务商系统',
  3: 'MP投放端',
  4: '附近推',
};
